// Landing and about pages: old map links.

// Map links used to live at "/#map=…"; they now open the map page.
export function legacyMapUrl(path, hash) {
  if (path !== "/" || !/(^#|&)(map|layer|forecast|depth)=/.test(hash || "")) return "";
  return `/map${hash}`;
}

export function start() {
  const target = legacyMapUrl(location.pathname, location.hash);
  if (target) {
    location.replace(target);
    return;
  }
  startMobileMenu();
}

function startMobileMenu() {
  const header = document.querySelector(".site-header");
  const toggle = header?.querySelector("[data-site-menu-toggle]");
  const nav = header?.querySelector("#site-primary-nav");
  if (!header || !toggle || !nav) return;

  const closeMenu = (returnFocus = false) => {
    header.removeAttribute("data-menu-open");
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Open navigation menu");
    if (returnFocus) toggle.focus();
  };

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      closeMenu();
      return;
    }
    header.setAttribute("data-menu-open", "true");
    toggle.setAttribute("aria-expanded", "true");
    toggle.setAttribute("aria-label", "Close navigation menu");
  });

  nav.addEventListener("click", (event) => {
    if (event.target.closest("a")) closeMenu();
  });

  document.addEventListener("click", (event) => {
    if (!header.contains(event.target)) closeMenu();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
      closeMenu(true);
    }
  });

  window.matchMedia("(max-width: 700px)").addEventListener("change", () => closeMenu());
}
